import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Container from "../../Components/General/Container";
import RightArrow from "../../assets/images/icons/rgt_arrow_vector_bl.png";
import { CASE_STUDIES } from "./data";
import styles from "./CaseStudy.module.css";

// Figma 11401:281478 — exactly two chips, "Raw Material" selected on load.
const TABS = ["Raw Material", "MetalCloud"];

export default function CaseStudy() {
  const [activeTab, setActiveTab] = useState(TABS[0]);

  // Index drives the detail route, so filter on the original list.
  const visible = useMemo(
    () =>
      CASE_STUDIES.map((cs, index) => ({ cs, index })).filter(
        ({ cs }) => cs.category === activeTab
      ),
    [activeTab]
  );

  return (
    <section className={styles.caseStudyPage}>
      <Container>
        <h1 className={styles.titleContainer}>Case Studies</h1>
        <div className={styles.filterBar}>
          <div className={styles.tabWrap}>
            {TABS.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActiveTab(tab)}
                className={`${styles.filterTab}${
                  tab === activeTab ? ` ${styles.filterTabActive}` : ""
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
        <div className={styles.caseStudyContainer}>
          {visible.map(({ cs, index }) => (
            <Link key={index} to={`/casestudy/${index}`} className={styles.caseStudyBlock}>
              <img
                className={styles.caseStudyImages}
                src={cs.thumbnail || cs.image}
                alt={cs.cardTitle || cs.title}
              />
              <div className={styles.content}>
                {cs.publishedOn && (
                  <p className={styles.publishDate}>Published on : {cs.publishedOn}</p>
                )}
                <div className={styles.textGroup}>
                  <h2 className={styles.subtitleText}>{cs.cardTitle || cs.title}</h2>
                  <div className={styles.description}>{cs.description}</div>
                </div>
                <div className={styles.mediaRedirectBtn}>
                  <span className={styles.readMoreText}>Read More</span>
                  <img src={RightArrow} alt="arrow" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}
